"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";
import { View, TouchableOpacity, StyleSheet, Dimensions } from "react-native";
import {
  ViewPropTypes,
  TextPropTypes,
} from "deprecated-react-native-prop-types";
import { faBackspace, faCheckSquare } from "../../assets/consts/faCharCodes";
import FontAwesomeIcon from "./FontAwesomeIcon";
import Text from "./TextFont";
import Theme from "../argon-ui/Theme";
import { HStack, VStack } from "native-base";
import Spinner from "./Spinner";
import { IS_WEB } from "../locales/translate";

const { height, width } = Dimensions.get("window");
const BACK = "back";
const CLEAR = "clear";
const PRESS_MODE_STRING = "string";

export default class VirtualKeyboard extends Component {
  static propTypes = {
    pressMode: PropTypes.oneOf(["string", "char"]),
    color: PropTypes.string,
    onPress: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    submitLoading: PropTypes.bool,
    applyBackspaceTint: PropTypes.bool,
    decimal: PropTypes.bool,
    decimalSymbol: PropTypes.string,
    rowStyle: ViewPropTypes.style,
    cellStyle: ViewPropTypes.style,
    submitBtnStyle: ViewPropTypes.style,
    textStyle: TextPropTypes.style,
    clearOnLongPress: PropTypes.bool,
  };

  static defaultProps = {
    pressMode: "string",
    color: Theme.COLORS.MUTED,
    applyBackspaceTint: true,
    decimal: false,
    clearOnLongPress: false,
    submitLoading: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      text: "",
    };
  }

  renderDecimal() {
    if (this.props.decimal) {
      return this.props.decimalSymbol
        ? this.Cell(this.props.decimalSymbol)
        : this.Cell(".");
    } else {
      // return <View style={{ flex: 1 }} />;
      return null;
    }
  }
  checkBtn() {
    if (!this.props.onSubmit) {
      return null;
    }
    return (
      <TouchableOpacity
        disabled={this.props.submitLoading}
        style={[
          styles.cell,
          styles.submitBtn,
          this.props.submitBtnStyle,
          this.props.submitLoading && {
            backgroundColor: Theme.COLORS.INPUT,
          },
        ]}
        onPress={() => {
          this.props.onSubmit && this.props.onSubmit();
        }}
      >
        {this.props.submitLoading ? (
          <View style={{ width: 30, height: 30 }}>
            <Spinner />
          </View>
        ) : (
          <FontAwesomeIcon
            icon={faCheckSquare}
            size={26}
            color={Theme.COLORS.SUCCESS}
          />
        )}
      </TouchableOpacity>
    );
  }

  render() {
    return (
      <VStack space="3" style={[styles.container, this.props.style]}>
        {IS_WEB ? (
          <>
            {this.Row([1, 2, 3])}
            {this.Row([4, 5, 6])}
            {this.Row([7, 8, 9])}
          </>
        ) : (
          <>
            {this.Row([3, 2, 1])}
            {this.Row([6, 5, 4])}
            {this.Row([9, 8, 7])}
          </>
        )}
        {/* {this.Row([1, 2, 3])} */}
        {/* {this.Row([3, 2, 1])} */}
        {/* {this.Row([4, 5, 6])} */}
        {/* {this.Row([6, 5, 4])} */}
        {/* {this.Row([7, 8, 9])} */}
        {/* {this.Row([9, 8, 7])} */}
        <HStack space="3" style={[this.props.rowStyle]}>
          {IS_WEB ? (
            <>
              {this.checkBtn()}
              {this.Cell(0)}
              {this.Backspace()}
              {this.renderDecimal()}
            </>
          ) : (
            <>
              {this.Backspace()}
              {this.Cell(0)}
              {this.renderDecimal()}
              {this.checkBtn()}
            </>
          )}
        </HStack>
      </VStack>
    );
  }

  Backspace() {
    return (
      <TouchableOpacity
        accessibilityLabel="backspace"
        style={styles.cell}
        onPress={() => {
          this.onPress(BACK);
        }}
        onLongPress={() => {
          if (this.props.clearOnLongPress) this.onPress(CLEAR);
        }}
      >
        <FontAwesomeIcon
          icon={faBackspace}
          size={20}
          color={this.props.color}
        />
      </TouchableOpacity>
    );
  }

  Row(numbersArray) {
    let cells = numbersArray.map((val) => this.Cell(val));
    return (
      <HStack space="3" style={[this.props.rowStyle]}>
        {cells}
      </HStack>
    );
  }

  Cell(symbol) {
    return (
      <TouchableOpacity
        style={[styles.cell, this.props.cellStyle]}
        key={symbol}
        accessibilityLabel={symbol.toString()}
        onPress={() => {
          this.onPress(symbol.toString());
        }}
      >
        <Text
          style={[
            styles.number,
            this.props.textStyle,
            { color: this.props.color },
          ]}
        >
          {symbol}
        </Text>
      </TouchableOpacity>
    );
  }

  onPress(val) {
    if (this.props.pressMode === PRESS_MODE_STRING) {
      let curText = this.state.text;
      if (isNaN(val)) {
        if (val === BACK) {
          curText = curText.slice(0, -1);
        } else if (val === CLEAR) {
          curText = "";
        } else {
          curText += val;
        }
      } else {
        curText += val;
      }
      this.setState({ text: curText });
      this.props.onPress(curText);
    } /* if (props.pressMode == 'char')*/ else {
      this.props.onPress(val);
    }
  }
}
const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
  },
  row: {},
  number: {
    fontSize: 25,
    textAlign: "center",
  },
  backspace: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  cell: {
    flex: 1,

    minHeight: 70,
    minWidth: 70,

    justifyContent: "center",
    alignItems: "center",

    padding: 5,
    borderRadius: 10,

    backgroundColor: Theme.COLORS.GRAY_LIGHT,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  submitBtn: {
    backgroundColor: Theme.COLORS.SUCCESS + 50,
    elevation: 0,
  },
});
